import { useEffect, useState } from "react";

export function FederatedHandoff() {
  const [message, setMessage] = useState("Finishing Google sign-in…");

  useEffect(() => {
    const token = new URLSearchParams(window.location.hash.slice(1)).get("t");
    window.history.replaceState(null, "", "/federated-entry");
    if (!token) {
      setMessage("This sign-in link is incomplete. Return to staff sign-in and try again.");
      return;
    }
    void fetch("/api/organizer/federated-handoff", {
      method: "POST",
      credentials: "same-origin",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ token }),
    }).then(async (response) => {
      const body = await response.json().catch(() => null) as { destination?: string; message?: string } | null;
      if (!response.ok || !body?.destination) throw new Error(body?.message ?? "Google sign-in could not be finished.");
      window.location.replace(body.destination);
    }).catch((error: unknown) => {
      setMessage(error instanceof Error ? error.message : "Google sign-in could not be finished.");
    });
  }, []);

  return <main className="school-portal-message" aria-live="polite"><h1>Verity Connect</h1><p>{message}</p></main>;
}
